import React from 'react';
import { MapPin, Phone, Mail, Clock, ShieldCheck } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-12 lg:py-16 bg-white" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-63">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-64">
            Get in Touch
          </h2>
          <p className="text-charcoal/70 text-base font-medium" data-id="element-65">
            Ready to take the first step? Reach out to schedule a consultation.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-66">
          <div data-id="element-67">
            <div className="bg-olive rounded-2xl p-6 md:p-8" data-id="element-68">
              <div className="flex items-center gap-2 text-gold mb-6 text-sm font-bold uppercase tracking-wide" data-id="element-69">
                <ShieldCheck size={18} data-id="element-70" />
                HIPAA-Compliant Secure Form
              </div>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-71">
                <div data-id="element-72">
                  <label htmlFor="fullName" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-73">
                    Full Name
                  </label>
                  <input type="text" id="fullName" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <label htmlFor="email" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-76">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-77" />
                </div>
                <div data-id="element-78">
                  <label htmlFor="phone" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-79">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <label htmlFor="service" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-82">
                    Service of Interest
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base" data-id="element-83">
                    <option value="" className="text-charcoal" data-id="element-84">
                      Select a service...
                    </option>
                    <option value="individual" className="text-charcoal" data-id="element-85">
                      Individual Counselling
                    </option>
                    <option value="couples" className="text-charcoal" data-id="element-86">
                      Couples Therapy
                    </option>
                    <option value="family" className="text-charcoal" data-id="element-87">
                      Family Therapy
                    </option>
                    <option value="trauma" className="text-charcoal" data-id="element-88">
                      Trauma Therapy
                    </option>
                    <option value="emdr" className="text-charcoal" data-id="element-89">
                      EMDR Therapy
                    </option>
                    <option value="consultation" className="text-charcoal" data-id="element-90">
                      Free Consultation
                    </option>
                  </select>
                </div>
                <div data-id="element-91">
                  <label htmlFor="message" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-92">
                    Message (Optional)
                  </label>
                  <textarea id="message" rows={3} className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all resize-none font-medium text-white text-base placeholder-white/30" placeholder="Please do not include sensitive medical information." data-id="element-93"></textarea>
                </div>
                <button type="submit" className="w-full bg-gold hover:bg-gold/90 text-white px-6 py-3.5 rounded-lg font-bold text-base transition-all shadow-soft min-h-[48px] uppercase tracking-wide" data-id="element-94">
                  Request Appointment
                </button>
              </form>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8" data-id="element-95">
            <div data-id="element-96">
              <h3 className="font-heading text-xl font-bold text-charcoal mb-5" data-id="element-97">
                Contact Information
              </h3>
              <div className="space-y-5" data-id="element-98">
                <div className="flex items-start gap-3" data-id="element-99">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-100">
                    <Phone size={18} data-id="element-101" />
                  </div>
                  <div data-id="element-102">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-103">
                      Phone
                    </p>
                    <a href="tel:5489000692" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base" data-id="element-104">
                      548-900-0692
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-105">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-106">
                    <Mail size={18} data-id="element-107" />
                  </div>
                  <div data-id="element-108">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-109">
                      Email
                    </p>
                    <a href="mailto:esther@esthermensahcounselling.com" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base break-all" data-id="element-110">
                      esther@esthermensahcounselling.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-111">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-112">
                    <MapPin size={18} data-id="element-113" />
                  </div>
                  <div data-id="element-114">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-115">
                      Office Location
                    </p>
                    <p className="text-charcoal/80 font-medium text-base" data-id="element-116">
                      370 Queens Avenue, London, Ontario
                    </p>
                    <div className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-bold text-olive bg-olive/10 px-2.5 py-1 rounded-full tracking-wide" data-id="element-117">
                      <span className="w-1.5 h-1.5 rounded-full bg-olive animate-pulse" data-id="element-118" />
                      Virtual Available
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-charcoal/10" data-id="element-119">
              <div className="flex items-center gap-2 mb-4" data-id="element-120">
                <Clock className="text-gold" size={20} data-id="element-121" />
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-122">
                  Office Hours
                </h3>
              </div>
              <ul className="space-y-2 text-charcoal/80 font-medium text-base" data-id="element-123">
                <li className="flex justify-between" data-id="element-124">
                  <span data-id="element-125">Monday - Thursday</span>
                  <span className="font-bold" data-id="element-126">9:00 AM - 7:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-127">
                  <span data-id="element-128">Friday</span>
                  <span className="font-bold" data-id="element-129">9:00 AM - 1:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-130">
                  <span data-id="element-131">Saturday - Sunday</span>
                  <span className="font-bold text-charcoal/40" data-id="element-132">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}